import { createColumnHelper } from '@tanstack/react-table';

import { QALog } from 'types/QALog';
import { Location } from 'types/washhub';
import { convertUTCToLocal } from 'utils/dateUtils';

const col = createColumnHelper<QALog>();

const getWashHubByID = (washHubs: Location[], washID?: string) => {
  let washHubById = '';

  if (!Boolean(washID)) return (washHubById = ' - ');

  const washHub = washHubs.find((wash) => wash?._id === washID);
  washHubById = washHub?.name || ' - ';
  return washHubById;
};

const calculateSum = (data: [], type: string) => {
  return data.reduce((sum, item: any) => {
    return sum + (type === 'total' ? item.total : item.yield);
  }, 0);
};

/**
 * The Wash Hub column only exists in the "all wash hubs" view (no selected
 * wash hub), exactly as the legacy header/row pair conditioned on !washHubId.
 */
export const buildQaLogColumns = (washHubId: string, washHubs: Location[]) => [
  col.accessor((qaLog) => qaLog?.logId || '-', {
    id: 'logId',
    header: 'Log ID',
    minSize: 80,
  }),
  ...(!washHubId
    ? [
        col.accessor(
          (qaLog) => getWashHubByID(washHubs, qaLog?.washHub || ''),
          {
            id: 'washHub',
            header: 'Wash Hub',
            minSize: 150,
          },
        ),
      ]
    : []),
  col.accessor((qaLog) => convertUTCToLocal(qaLog?.date, true, true), {
    id: 'date',
    header: 'QA Log Date',
    minSize: 150,
    meta: { sortField: 'date' },
  }),
  col.accessor(
    (qaLog) =>
      `${qaLog?.employee?.fname ?? ''} ${qaLog?.employee?.lname ?? ''}`,
    {
      id: 'employeeName',
      header: 'Employee Name',
      minSize: 150,
    },
  ),
  col.accessor((qaLog) => calculateSum(qaLog?.items, 'total'), {
    id: 'totalInspected',
    header: 'Total Inspected',
    minSize: 100,
  }),
  col.accessor(
    (qaLog) => {
      const passedSum = qaLog?.items.reduce((sum, item: any) => {
        return sum + (item.passed || 0);
      }, 0);

      const totalSum = qaLog?.items.reduce((sum, item: any) => {
        return sum + (item.total || 0);
      }, 0);

      const passedPercent = totalSum > 0 ? (passedSum / totalSum) * 100 : 0;

      return `${passedPercent?.toFixed(2)}%`;
    },
    {
      id: 'totalYield',
      header: 'Total Yield',
      minSize: 100,
    },
  ),
  col.accessor((qaLog) => qaLog?.notes, {
    id: 'notes',
    header: 'notes',
    minSize: 200,
    size: 320,
  }),
];
